<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="系统编号">
              <a-input v-model="queryParam.number" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="名称">
              <a-input v-model="queryParam.name" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="类型">
              <a-select v-model="queryParam.type" allow-clear placeholder="请选择" default-value="0" @keyup.enter.native="$refs.table.refresh(true)">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_material_type">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="4" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1000 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="archived" slot-scope="text, item">
        <a-popconfirm
          title="确定存档吗?"
          :disabled="text"
          @confirm="() => archived(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleAttachment(record)">附件</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id) && !record.is_archived"/>
          <a @click="handleEdit(record)" v-if="isEdited(record.create_by_id) && !record.is_archived">编辑</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id) && !record.is_archived"/>
          <a-popconfirm
            v-if="isEdited(record.create_by_id) && !record.is_archived"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <archived-form
      ref="archivedModal"
      v-if="archived_visible"
      :visible="archived_visible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import {
  project_material_list,
  project_material_create,
  project_material_delete,
  project_material_archived,
  project_material_update
} from '@/api/trade_project_material'
import CreateForm from '../modules/CreateForm'
import ArchivedForm from '../modules/ArchivedForm'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    ArchivedForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archived_visible: false,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '系统编号',
          dataIndex: 'number',
          width: 150,
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 150,
          ellipsis: true
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 150,
          ellipsis: true
        },
        {
          title: '类型',
          dataIndex: 'type',
          ellipsis: true,
          width: 120,
          customRender: (text) => this.$Dictionaries.trade_material_type[text] || '无'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 150,
          ellipsis: true
        },
        {
          title: '已存档',
          dataIndex: 'is_archived',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'archived' }
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '时间',
          width: 180,
          dataIndex: 'create_time',
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '210px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return project_material_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      this.mdl = { number: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDate() }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachment (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project_material/' + record.id + '/attachment', query: { record: record.name } })
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project_material/' + record.id })
    },
    archived (record) {
      project_material_update({ is_archived: !record.is_archived }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleDelete (record) {
      project_material_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          values['attachment'] = data['attachment']
          this.confirmLoading = true
          project_material_create(values).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
              this.visible = false
              // 重置表单数据
              form.resetFields()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          project_material_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archived_visible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
